"use strict";
import Common from "./Common";

const disp = [];

export default class SplashScene extends p3.Scene {
    constructor() {
        super();

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._bg = null;

        /**
         *
         * @type {PIXI.Container}
         * @private
         */
        this._primaryHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._uiHolder = new PIXI.Container();

        /**
         * @type {Array}
         * @private
         */
        this._particles = [];

        /**
         * @type {Array}
         * @private
         */
        this._happos = [];

        /**
         * @type {Array}
         * @private
         */
        this._containers = [];
    }

    init() {

        //load saved data if it exists
        Common.loadGame();

        //add to containers
        this.addChild(this._primaryHolder, this._uiHolder);
        this._containers = [this._primaryHolder, this._uiHolder];

        //create bg
        this._bg = createSprite("bg", this._primaryHolder);

        //init display objects
        this.initDisp();

        //init ui elements
        this.initUI();

        //--play sounds--//

        Common.audio.playSound("music_results_long_00");
        Common.audio.playSound("sfx_ambient_desert_loop_00", true);

        this.start();
    }

    start() {
        this._running = true;
        this.jumpHappo();
    }

    end() {
        this._running = false;
        this.signals.next.dispatch(this);
    }

    initDisp() {


        let happo3 = this.createHappo("happo_3", this._primaryHolder);
        ///  let happo2 = createSprite("happo_2", this._primaryHolder);

        //   let emitter =


        let banner = createSprite("banner", this._primaryHolder);
        banner.x = 168;
        banner.y = 160;

        let happo1 = this.createHappo("happo_1", this._primaryHolder);
        let happo4 = this.createHappo("happo_4", this._primaryHolder);
        let happo5 = this.createHappo("happo_5", this._primaryHolder);
        happo5.x = 459;
        happo5.y = 111;


        const shadow = createSprite("shadow", this._primaryHolder);
        let happoStunt = this.createHappo("stunt_endgame", this._primaryHolder);
        happoStunt.x = 359;
        happoStunt.y = p3.View.height - 35;
        shadow.anchor.set(0.5, 1);
        shadow.position.set(happoStunt.x + 15, happoStunt.y + 15);

        happo1.x = -376;
        happo1.y = p3.View.height - 15;

        happo4.x = 575;
        happo4.y = p3.View.height - 25;

        happo3.x = -150;
        happo3.y = p3.View.height - 55;

        let obj = happo3;
        obj.shadow.position.set(obj.x, obj.y + 5);
        obj = happo1;
        obj.shadow.position.set(obj.x, obj.y + 5);
        obj = happo4;
        obj.shadow.position.set(obj.x, obj.y + 5);
        //  this.makeDraggable(happo4);
        /*
         let bannerTxtView = new PIXI.extras.BitmapText("Well Done!\nYou've flown\n" + Common.flyDist + " M.\nBest score " + Common.highScores[0] + " M.", {
         font: "55px Ziclets",
         align: "center",
         tint: 0x2958a1
         });
         /*
         /*
         new PIXI.Text("Well Done!\nYou've flown\n" + Common.flyDist + " M.\nBest score " + Common.highScores[0] + " M.", {
         fontFamily: "arial",
         fontSize: "50px",
         align: "center"
         });
         */

        const extraPad = (Common.flyDist.toString().length >= 5);

        let bannerTxtView = new PIXI.extras.BitmapText(Common.copy.well_done[Common.language], {
            font: "55px Ziclets",
            align: "center",
            tint: 0x2958a1
        });
        let bannerTxtView2 = new PIXI.extras.BitmapText(Common.copy.distance[Common.language], {
            font: "35px VAGRounded-Light",
            align: "center",
            tint: 0x2958a1
        });
        let bannerTxtView3 = new PIXI.extras.BitmapText("" + Common.flyDist + " M.", {
            font: "75px Ziclets",
            align: "center",
            tint: 0xd21402
        });
        let bannerTxtView4 = new PIXI.extras.BitmapText(Common.copy.best_score[Common.language] + " " + Common.highScores[0] + " M.", {
            font: "35px VAGRounded-Light",
            align: "center",
            tint: 0x2958a1
        });


        bannerTxtView.anchor.set(0.5);
        bannerTxtView2.anchor = bannerTxtView3.anchor = bannerTxtView4.anchor = bannerTxtView.anchor;
        banner.addChild(bannerTxtView, bannerTxtView2, bannerTxtView3, bannerTxtView4);

        bannerTxtView.x = bannerTxtView2.x = bannerTxtView3.x = bannerTxtView4.x = -150;
        bannerTxtView.y = 75;
        bannerTxtView2.y = bannerTxtView.y + 75;
        bannerTxtView3.y = bannerTxtView2.y + 35;
        bannerTxtView4.y = bannerTxtView3.y + 85;

        let star = createSprite("star", banner);
        let star2 = createSprite("star", banner);
        star.anchor.set(0.5);
        star2.anchor.set(0.5);
        star.y = star2.y = 215;
        star.x = -300;

        star.x -= 25;
        star2.x += 25;

        if (extraPad) {
            star.x -= 25;
            star2.x += 25;
        }

        //--make particles--//
        const config = Common.assets.getJSON("particles_gameover");
        let emitter = new PIXI.particles.Emitter(this._uiHolder, [Common.assets.getTexture("part_1"), Common.assets.getTexture("part_2"), Common.assets.getTexture("part_3"), Common.assets.getTexture("part_4"), Common.assets.getTexture("part_5"), Common.assets.getTexture("part_6"), Common.assets.getTexture("part_7")], config);
        emitter.updateSpawnPos(25, 200);
        this._particles.push(emitter);
        emitter.emit = true;
    }

    initUI() {

        var playClick = () => {
            this.signals.next.dispatch(this);
        };
        const btnReplay = Common.createButton(0, p3.View.height * 0.5 + 225, "big", playClick, this, this._uiHolder, "icon_replay");

        var muteClick = () => {
            Common.isMute = !Common.isMute;
            Common.audio.mute(Common.isMute);
            if (!Common.isMute) this.soundBtn.icon.texture = Common.assets.getTexture("icon_sound_on");
            else this.soundBtn.icon.texture = Common.assets.getTexture("icon_sound_off");
        };
        this.soundBtn = Common.createButton(p3.View.width * 0.5 - 75, 65, "small", muteClick, this, this._uiHolder, "icon_sound_off");
        if (!Common.isMute) this.soundBtn.icon.texture = Common.assets.getTexture("icon_sound_on");

        var homeClick = () => {
            this.signals.home.dispatch(this);
        };
        this.homeBtn = Common.createButton(-p3.View.width * 0.5 + 75, 65, "small", homeClick, this, this._uiHolder, "icon_home");
    }

    jumpHappo() {
        const delayTime = 4;
        var jump = () => {
            const rand = Math.floor(Math.random() * this._happos.length);
            const happo = this._happos[rand];
            happo.tween.pause();
            TweenMax.to(happo, 0.25, {y: happo.y - 25, yoyo: true, repeat: 1});
            TweenMax.to(happo.scale, 0.25, {
                x: happo.scale.x - 0.05,
                y: happo.scale.y + 0.05,
                yoyo: true,
                repeat: 1,
                onComplete: ()=> {
                    happo.tween.resume();
                }
            });
            delay(jump, delayTime, this);
        };
        delay(jump, delayTime, this);
    }


    createHappo(name, holder) {
        let shadow = createSprite("shadow", holder);
        shadow.anchor.set(0.5, 1);
        let obj = createSprite(name, holder);
        obj.anchor.y = 1;
        obj.scale.set(0.8);
        obj.tween = TweenMax.to(obj.scale, 1, {
            x: obj.scale.x + 0.02,
            y: obj.scale.y - 0.02,
            ease: Power0.easeNone,
            yoyo: true,
            repeat: -1,
            repeatDelay: 0.15 + Math.random * 0.2,
            delay: Math.random()
        });
        if (name !== "happo_5") this._happos.push(obj);
        obj.shadow = shadow;
        return obj;
    }

    destroy() {
        //Common.animator.removeAll();
        Common.audio.stopSound("sfx_ambient_desert_loop_00");
        TweenMax.killAll();

        for (let i = 0; i < disp.length; i++) {
            disp[i].destroy();
            disp[i] = null;
            delete disp[i];
        }
        disp.length = 0;

        for (let i = 0; i < this._containers.length; i++) {
            this._containers[i].destroy();
            this._containers[i] = null;
            delete this._containers[i];
        }
        this._containers.length = 0;

        for (let i = 0; i < this._particles.length; i++) {
            this._particles[i].destroy();
            this._particles[i] = null;
            delete this._particles[i];
        }
        this._particles.length = 0;
        Common.renderer.plugins.sprite.sprites.length = 0;

        super.destroy();
    }

    resize() {
        this.x = p3.View.width * 0.5;
        this.homeBtn.x = -p3.View.width * 0.5 + 75;
        this.soundBtn.x = p3.View.width * 0.5 - 75;
    }

    update() {
        if (this.dragging) {
            const pos = this.dragging.inputData.getLocalPosition(this);
            this.dragging.position.set(pos.x, pos.y);
        }

        for (let i in this._particles) {
            this._particles[i].update(deltaTime);
        }
    }
}

function createSprite(texture, holder) {
    let sprite;
    if (typeof texture === "string") sprite = new PIXI.Sprite(Common.assets.getTexture(texture));
    else if (texture instanceof PIXI.Texture) sprite = new PIXI.Sprite(texture);
    sprite.anchor = {x: 0.5, y: 0};
    if (holder) holder.addChild(sprite);
    return sprite;
}